// Copyright 2025, University of Maryland, All Rights Reserved
import { useState } from 'react';
import { AlertTriangle, Upload } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@umd-dit-ai-workspace/shared-ui';
import { TemplatesConfigurationView } from './TemplatesConfigurationView';
import { PromptsConfigurationView } from './PromptsConfigurationView';
import { MigrationModal } from './MigrationModal';

export function DefaultsConfigurationView() {
  const [showMigrationModal, setShowMigrationModal] = useState(false);

  return (
    <>
      <div className="mb-6 flex items-center space-x-4">
        <div className="flex items-center space-x-2 text-sm text-amber-700 bg-amber-50 px-3 py-1 rounded-md">
          <AlertTriangle className="w-4 h-4" />
          <span>Admin access required - changes affect system defaults</span>
        </div>
        <button
          onClick={() => setShowMigrationModal(true)}
          className="flex items-center space-x-2 px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
        >
          <Upload className="w-4 h-4" />
          <span>Migrate from Local</span>
        </button>
      </div>

      <Tabs defaultValue="templates">
        <TabsList className="mb-6">
          <TabsTrigger value="templates">📋 Templates</TabsTrigger>
          <TabsTrigger value="prompts">💬 Prompts</TabsTrigger>
        </TabsList>

        <TabsContent value="templates">
          <TemplatesConfigurationView level="default" />
        </TabsContent>

        <TabsContent value="prompts">
          <PromptsConfigurationView level="default" />
        </TabsContent>
      </Tabs>

      <MigrationModal
        show={showMigrationModal}
        onClose={() => setShowMigrationModal(false)}
      />
    </>
  );
}
